import { render, staticRenderFns } from "./inviteEmployees.vue?vue&type=template&id=c60ead5e&scoped=true"
import script from "./inviteEmployees.vue?vue&type=script&lang=js"
export * from "./inviteEmployees.vue?vue&type=script&lang=js"
import style0 from "./inviteEmployees.vue?vue&type=style&index=0&id=c60ead5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60ead5e",
  null
  
)

export default component.exports